import { gql } from '@apollo/client'
import config from '@config'

export enum VIDEOTYPE {
    SUPPORTMATERIAL = 1,
    MATERIAL = 2,
    TRAILER = 3
}

export const TOPICS = {
    DAILYFEED_NOTIFICATION: `DAILYFEED_NOTIFICATION_${config.ENVIRONMENT}`,
    NEWS_NOTIFICATION: `NEWS_NOTIFICATION_${config.ENVIRONMENT}`,
    SPECIALOFFERS_NOTIFICATION: `SPECIALOFFERS_NOTIFICATION_${config.ENVIRONMENT}`,
    APPUPDATE_NOTIFICATION: `APPUPDATE_NOTIFICATION_${config.ENVIRONMENT}`,
}

export enum CacheKey {
    COURSES_KEY = 'COURSES_KEY',
    SUPPORTMATERIALS_KEY = 'SUPPORTMATERIALS_KEY',
}

export const JOBCONVERTSTATUS = {
    CANCELED: 'CANCELED',
    COMPLETE: 'COMPLETE',
    ERROR: 'ERROR',
    PROGRESSING: 'PROGRESSING',
    SUBMITTED: 'SUBMITTED',
}

export const UPLOADSTATUS = {
    UPLOADED: 'UPLOADED'
}

export const ResetCacheDB = gql`
    mutation ResetCacheDB($isAllKeyReset: Boolean!, $cacheKeyList: [String]) {
        resetCacheDB (input: {
            isAllKeyReset: $isAllKeyReset,
            cacheKeyList: $cacheKeyList
        }){
            messages
            errorMessages
            isError
            result
        }
    }
`

export const UpdateGeneralSetting = gql`
    mutation UpdateGeneralSetting($settings: [GeneralSettingLiteRequestType] ) {
        updateGeneralSetting(input: {
            settings: $settings
        }) {
            messages
            errorMessages
            isError
            result    
        }
    }
`

export const RegisterVideoProgress = gql`
    mutation RegisterVideoProgress($videoId: Int!, $uploadId: String!, $uploadStatus: String!, $jobConvertId: String!, $jobConvertStatus: String!) {
        registerVideoProgress (input: {
            videoId: $videoId,
            uploadId: $uploadId,
            uploadStatus: $uploadStatus,
            jobConvertId: $jobConvertId,
            jobConvertStatus: $jobConvertStatus
        }){
            messages
            errorMessages
            isError
            result
        }
    }
`

export const CreateMediaConvertJob = gql`
    mutation CreateMediaConvertJob($fileKeyPath: String!) {
        createMediaConvertJob(fileKeyPath: $fileKeyPath) {
            messages
            errorMessages
            result
            isError
        }
    }
`

export const CreateVideoMaterial = gql`
    mutation CreateVideoMaterial($name: String!, $sequence: Int, $videoDuration: Int!, $videoType: VideoTypeEnum!, $videoURL: String!, $inputVideoURL: String!) {
        createVideoMaterial (input: {
            name: $name,
            sequence: $sequence,
            videoDuration: $videoDuration,
            videoType: $videoType,
            videoURL: $videoURL,
            inputVideoURL: $inputVideoURL,
        }){
            messages
            errorMessages
            result
            isError
        }
    }
`

export const UpdateVideoMaterial = gql`
    mutation UpdateVidoMaterial($id: Int!, $name: String!, $description: String, $sequence: Int!, $videoType: VideoTypeEnum!) {
        updateVideoMaterial(id: $id, 
        input: {
            name: $name,
            description: $description,
            sequence: $sequence,
            videoType: $videoType    
        }) {
            messages
            errorMessages
            result
            isError
        }
    }
`



